// import { useState } from "react";
import styled from "styled-components";

import {
  Grid,
  Stack,
  IconButton,
  // FormHelperText,
  // TextField,
  InputAdornment,
} from "@mui/material";
import TextField from "src/components/core/TextField";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "src/components/icon/Image";

import font from "src/styles/font";
import { DarkGrey, White01 } from "src/styles/color";

const S = {};

S.PreviewImageUploadBox = styled.div`
  position: relative;
  padding-top: 100%;
  background-color: ${White01};
  border-radius: 16px;
  /* grid-column: span 7; */
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.sm};
  font-weight: 500;
  color: ${DarkGrey};
  margin-top: 8px;

  &::after {
    content: "*";
    font-weight: 600;
    color: #e04132;
  }
`;

S.UploadHelperText = styled.span`
  display: flex;
  justify-content: center;
  font-size: ${font.size.xs};
  color: ${DarkGrey};
  text-align: center;
  white-space: pre-line;
  margin-top: 8px;
`;

S.UploadedPreviewImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  object-fit: cover;
`;

const MetaTagComponent = ({
  keyImg = "metaTagIconFieldHandle",
  metatagData,
  setMetatagData,
}) => {
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={9}
          md={9.5}
          sx={{
            pr: 3,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <TextField
            label="หัวเรื่อง"
            variant="outlined"
            required
            value={metatagData?.title}
            onChange={(e) =>
              setMetatagData({
                ...metatagData,
                title: e.target.value,
              })
            }
            fullWidth
            inputProps={{ maxLength: 50 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {metatagData?.title?.length}/50
                </InputAdornment>
              ),
            }}
            error={!metatagData?.title}
          />

          <TextField
            label="รายละเอียด"
            variant="outlined"
            required
            value={metatagData?.desc}
            onChange={(e) =>
              setMetatagData({
                ...metatagData,
                desc: e.target.value,
              })
            }
            fullWidth
            inputProps={{ maxLength: 100 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {metatagData?.desc?.length}/100
                </InputAdornment>
              ),
            }}
            error={!metatagData?.desc}
          />

          <TextField
            label="คีย์เวิร์ด"
            placeholder="ตัวอย่าง: ดีลสุดคุ้ม ลามิเนต ลดราคา"
            variant="outlined"
            required
            value={metatagData?.keywords}
            onChange={(e) =>
              setMetatagData({
                ...metatagData,
                keywords: e.target.value,
              })
            }
            fullWidth
            inputProps={{ maxLength: 50 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {metatagData?.keywords?.length}/50
                </InputAdornment>
              ),
            }}
            error={!metatagData?.keywords}
          />
        </Grid>

        <Grid item xs={3} md={2.5}>
          <S.PreviewImageUploadBox>
            {!metatagData?.img ? (
              <S.UploadInnerBox>
                <Stack flexDirection={"row"}>
                  <input
                    id={keyImg}
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      e.preventDefault();
                      setMetatagData({
                        ...metatagData,
                        img: e.target.files[0],
                      });
                    }}
                    onClick={(e) => (e.currentTarget.value = null)}
                  />
                  <S.UploadInput htmlFor={keyImg}>
                    <ImageIcon size={24} color="#6C6C70" />
                    <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                    <S.UploadHelperText>
                      {`รูปภาพขนาด 1000x1000 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                    </S.UploadHelperText>
                  </S.UploadInput>
                </Stack>
              </S.UploadInnerBox>
            ) : (
              <>
                <S.UploadedPreviewImage
                  src={
                    typeof metatagData?.img === "string"
                      ? metatagData?.img
                      : URL.createObjectURL(metatagData?.img)
                  }
                  alt=""
                />
                <Stack
                  sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                  }}
                  flexDirection={"row"}
                  columnGap={1}
                >
                  <IconButton
                    sx={{
                      padding: "4px",
                      backgroundColor: "#BCBCC0bd",
                    }}
                    onClick={() => {
                      setMetatagData({
                        ...metatagData,
                        img: null,
                      });
                    }}
                  >
                    <CloseIcon sx={{ color: "#ffffff" }} />
                  </IconButton>
                </Stack>
              </>
            )}
          </S.PreviewImageUploadBox>
          {/* {!metatagData?.img && (
            <FormHelperText error={!metatagData?.img}>
              กรุณาเลือกรูปโฮเวอร์
            </FormHelperText>
          )} */}
        </Grid>
      </Grid>
    </>
  );
};

export default MetaTagComponent;
